import Cookies from 'js-cookie';

document.addEventListener("DOMContentLoaded", function() {

	//if this is the tyres archive
	if(document.body.classList.contains('post-type-archive-tyre')) {

		//fetch all URL parameters
		const params = new URLSearchParams(window.location.search);

		//this will hold our compiled params
		let json = {};

		//this will indicate whether our search is valid or not by the end
		let valid_search = false;

		//loop over each key in the array
		for (const key of params.keys()) {

			//if we have one of our core search values
			if(!valid_search && (key === 'width' && params.get(key) || key === 'profile' && params.get(key) || key === 'rim' && params.get(key))) {

				//mark this search as valid
				valid_search = true;
			}

			//append to the json
			json[key] = params.get(key);
		}

		//if our search is valid
		if(valid_search) {

			//save this as a cookie
			Cookies.set('bt_search', JSON.stringify(json), {expires: 1});
		}
	}
});